export enum SourcingAllyEventTypes {
    userLogin = 'USER_LOGIN',
    sourcingRequest = 'SOURCING_REQUEST',
    feedback = 'FEEDBACK',
    newUser = 'NEW_USER',
    updatedUser = 'UPDATED_USER',
    deletedUser = 'DELETED_USER',
    subscriptionUpgrade = 'SUBSCRIPTION_UPGRADE',
    subscriptionDowngrade = 'SUBSCRIPTION_DOWNGRADE',
    subscriptionCancel = 'SUBSCRIPTION_CANCEL',
    subscriptionRenew = 'SUBSCRIPTION_RENEW',
    subscriptionPayment = 'SUBSCRIPTION_PAYMENT',
    subscriptionRefund = 'SUBSCRIPTION_REFUND',
}